import React from "react";
import { cn } from "../../lib/utils";

export const Table = React.forwardRef(({ className, ...props }, ref) => (
  <div className="relative w-full overflow-auto scrollbar-thin">
    <table ref={ref} className={cn("w-full caption-bottom text-sm", className)} {...props} />
  </div>
));
Table.displayName = "Table";

export const TableHeader = ({ className, ...props }) => (
  <thead className={cn("bg-surface", className)} {...props} />
);
export const TableBody = ({ className, ...props }) => (
  <tbody className={cn("divide-y divide-border", className)} {...props} />
);
export const TableRow = ({ className, ...props }) => (
  <tr className={cn("border-b border-border transition-colors hover:bg-surface", className)} {...props} />
);
export const TableHead = ({ className, ...props }) => (
  <th
    className={cn(
      "h-10 px-4 text-left align-middle text-[11px] font-semibold uppercase tracking-[0.15em] text-muted-foreground",
      className
    )}
    {...props}
  />
);
export const TableCell = ({ className, ...props }) => (
  <td className={cn("px-4 py-3 align-middle text-sm", className)} {...props} />
);
